import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";
import Button from "@mui/material/Button";
import { COLOR_WHITE } from "shared/theme/colors";

type StyledButtonProps = {
  "data-loading"?: string;
};

const glow = keyframes`
  0% { box-shadow: 0 0 4px rgba(206, 92, 251, 0.7); }
  50% { box-shadow: 0 0 12px rgba(43, 120, 255, 0.9); }
  100% { box-shadow: 0 0 4px rgba(206, 92, 251, 0.7); }
`;

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const StyledAIButton = styled(Button)<StyledButtonProps>`
  position: relative;
  overflow: hidden;
  font-weight: 700;
  font-size: 1rem;
  line-height: 1.5;
  text-transform: none;
  border-radius: 8px;
  padding: 0 8px 0 16px;
  height: 34px;
  color: ${COLOR_WHITE};
  min-width: fit-content;
  width: 94px;
  background: #3c82fd !important;

  &::after {
    content: "";
    position: absolute;
    inset: -2px;
    z-index: 0;
    background: linear-gradient(
        270deg,
        rgba(246, 142, 180, 0.56) 0%,
        rgba(206, 92, 251, 0.56) 50.06%,
        rgba(43, 120, 255, 0.56) 100%
      ),
      #3c82fd;
    transition: opacity 0.3s ease;
  }

  .button-content {
    display: flex;
    align-items: center;
    gap: 8px;
    transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
    width: 100%;
    justify-content: center;
    opacity: 1;
    transform: scale(1);
    position: relative;
    z-index: 2;
  }

  transition:
    opacity 0.3s ease,
    border-radius 0.5s cubic-bezier(0.4, 0, 0.2, 1),
    width 0.5s cubic-bezier(0.4, 0, 0.2, 1),
    min-width 0.5s cubic-bezier(0.4, 0, 0.2, 1),
    padding 0.5s cubic-bezier(0.4, 0, 0.2, 1),
    transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    z-index: 1;
    background: conic-gradient(
      from 0deg,
      #3c82fd,
      rgba(206, 92, 251, 0.8),
      rgba(246, 142, 180, 0.8),
      #3c82fd
    );
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &[data-loading="true"] {
    cursor: default;
    border-radius: 100px;
    width: 34px;
    min-width: 34px;
    padding: 0;
    background: transparent;
    transform: scale(1);

    &::after {
      opacity: 0;
    }

    .button-content {
      position: relative;
      transform: scale(0.8);
      opacity: ${(props: StyledButtonProps) =>
        props["data-loading"] === "true" ? 1 : 0};
    }

    &::before {
      content: "";
      position: absolute;
      inset: 0;
      background: conic-gradient(
        from 0deg,
        #3c82fd,
        rgba(206, 92, 251, 0.8),
        rgba(246, 142, 180, 0.8),
        #3c82fd
      );
      animation: ${spin} 1s linear infinite;
      opacity: 1;
      transition: opacity 0.3s ease;
    }

    animation: ${glow} 3s ease-in-out infinite;
  }

  &:hover {
    &::after {
      opacity: 0.9;
    }
  }
`;
